import {configureStore} from '@reduxjs/toolkit';
import {rootReducer} from './reducers';

export function createGalleryStore(initialState) {
  return configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
  });
}
